import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/mutation-types.js'), 'mutation-types.js')
  resolveStoreModules(require('../store/upsell/index.js'), 'upsell/index.js')
  resolveStoreModules(require('../store/upsell-sequence/index.js'), 'upsell-sequence/index.js')
  resolveStoreModules(require('../store/tapptitude/index.js'), 'tapptitude/index.js')
  resolveStoreModules(require('../store/payment/index.js'), 'payment/index.js')
  resolveStoreModules(require('../store/have-lead/index.js'), 'have-lead/index.js')
  resolveStoreModules(require('../store/footer/index.js'), 'footer/index.js')
  resolveStoreModules(require('../store/detected-country/index.js'), 'detected-country/index.js')
  resolveStoreModules(require('../store/common/index.js'), 'common/index.js')
  resolveStoreModules(require('../store/brand/index.js'), 'brand/index.js')
  resolveStoreModules(require('../store/auth/index.js'), 'auth/index.js')
  resolveStoreModules(require('../store/auth/actions.js'), 'auth/actions.js')
  resolveStoreModules(require('../store/auth/getters.js'), 'auth/getters.js')
  resolveStoreModules(require('../store/brand/getters.js'), 'brand/getters.js')
  resolveStoreModules(require('../store/common/actions.js'), 'common/actions.js')
  resolveStoreModules(require('../store/common/getters.js'), 'common/getters.js')
  resolveStoreModules(require('../store/detected-country/actions.js'), 'detected-country/actions.js')
  resolveStoreModules(require('../store/detected-country/getters.js'), 'detected-country/getters.js')
  resolveStoreModules(require('../store/footer/actions.js'), 'footer/actions.js')
  resolveStoreModules(require('../store/footer/getters.js'), 'footer/getters.js')
  resolveStoreModules(require('../store/have-lead/actions.js'), 'have-lead/actions.js')
  resolveStoreModules(require('../store/have-lead/getters.js'), 'have-lead/getters.js')
  resolveStoreModules(require('../store/logger/actions.js'), 'logger/actions.js')
  resolveStoreModules(require('../store/payment/actions.js'), 'payment/actions.js')
  resolveStoreModules(require('../store/payment/getters.js'), 'payment/getters.js')
  resolveStoreModules(require('../store/tapptitude/actions.js'), 'tapptitude/actions.js')
  resolveStoreModules(require('../store/upsell-sequence/actions.js'), 'upsell-sequence/actions.js')
  resolveStoreModules(require('../store/upsell-sequence/getters.js'), 'upsell-sequence/getters.js')
  resolveStoreModules(require('../store/upsell/actions.js'), 'upsell/actions.js')
  resolveStoreModules(require('../store/upsell/getters.js'), 'upsell/getters.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
